import util from '@bmp-vue/core/api/util'
const controller = 'DivergenciaDeContas'
export default Object.assign({}, util.GetCrud(controller, ['getall', 'get', 'put', 'delete']), {   
  GetRelatorioDivergenciaDeContas(dto){
    return util.Axios.GetAll(`${controller}/GetRelatorioDivergenciaDeContas`, dto)
    }
})
